import { Button, Modal, theme, Typography } from 'antd'
import React from 'react'
import { useRestoreWindowScroll } from './holdWindowScroll'

const { Paragraph } = Typography

interface Props {
  readonly open: boolean
  readonly fileName: string | null
  readonly confirmLoading: boolean
  readonly onCancel: () => void
  readonly onConfirm: () => void
  readonly afterClose?: () => void
}

const FOOTER_BACKGROUND = '#f7f9fc'
const TITLE_COLOR = '#111726'
const BODY_TEXT_COLOR = '#3c4b61'

export function DeleteConfirmationModal({
  open,
  fileName,
  confirmLoading,
  onCancel,
  onConfirm,
  afterClose,
}: Props) {
  const { token } = theme.useToken()
  const restoreWindowScroll = useRestoreWindowScroll(open)

  return (
    <Modal
      afterOpenChange={restoreWindowScroll}
      afterClose={afterClose}
      title={
        <span style={{ fontSize: 18, fontWeight: 600, color: TITLE_COLOR }}>
          Delete analysis file
        </span>
      }
      open={open}
      onCancel={confirmLoading ? undefined : onCancel}
      closable={!confirmLoading}
      maskClosable={!confirmLoading}
      width={400}
      styles={{
        content: {
          padding: 0,
          overflow: 'hidden',
          borderRadius: 12,
          border: `1px solid ${token.colorBorder}`,
        },
        header: { margin: 0, padding: '16px 16px 0' },
        body: { padding: 16 },
        footer: {
          margin: 0,
          padding: 16,
          display: 'flex',
          justifyContent: 'flex-end',
          gap: 8,
          background: FOOTER_BACKGROUND,
          borderTop: `1px solid ${token.colorBorder}`,
        },
      }}
      footer={
        <>
          <Button
            style={{ borderRadius: 10 }}
            onClick={onCancel}
            disabled={confirmLoading}
          >
            Cancel
          </Button>
          <Button
            style={{ borderRadius: 10 }}
            type="primary"
            danger
            onClick={onConfirm}
            loading={confirmLoading}
          >
            Delete
          </Button>
        </>
      }
      destroyOnClose
    >
      <Paragraph
        style={{
          margin: 0,
          fontSize: 14,
          lineHeight: '18px',
          color: BODY_TEXT_COLOR,
        }}
      >
        Delete "{fileName ?? ''}"? This action cannot be undone.
      </Paragraph>
    </Modal>
  )
}
